<template>
    <sidebar-menu :items="items" has-icon />
</template>

<script>
import SidebarMenu from '@/components/sidebar/SidebarMenu.vue';

export default {
    name: 'InstitutionSettingsSidebar',

    components: {
        SidebarMenu,
    },

    computed: {
        items() {
            return [
                {
                    type: 'item',
                    title: 'Institution Profile',
                    route: { name: 'institution-settings-profile' },
                    icon: 'pi pi-building',
                    canSee: this.$gate.allows('viewAny', 'InstitutionSetting'),
                },
                {
                    type: 'item',
                    title: 'Contact & Support',
                    route: { name: 'institution-settings-contact-support' },
                    icon: 'pi pi-question-circle',
                    canSee: this.$gate.allows('viewAny', 'InstitutionSetting'),
                },
                {
                    type: 'item',
                    title: 'Email & Reminders',
                    route: { name: 'institution-settings-email-reminders' },
                    icon: 'pi pi-envelope',
                    canSee: this.$gate.allows('viewAny', 'InstitutionSetting'),
                },
                {
                    type: 'item',
                    title: 'System Notifications',
                    route: { name: 'institution-settings-system-notifications' },
                    icon: 'bell',
                    canSee: this.$gate.allows('viewAny', 'InstitutionSetting'),
                },
                {
                    type: 'item',
                    title: 'Course Lifecycle & Grades',
                    route: { name: 'institution-settings-course-lifecycle-grades' },
                    icon: 'pi pi-graduation-cap',
                    canSee: this.$gate.allows('viewAny', 'InstitutionSetting'),
                },
                {
                    type: 'item',
                    title: 'Identity Verification',
                    route: { name: 'institution-settings-identity-verification' },
                    icon: 'pi pi-user',
                    canSee: this.$gate.allows('viewAny', 'InstitutionSetting'),
                },
                {
                    type: 'item',
                    title: 'Attestation',
                    route: { name: 'institution-settings-attestation' },
                    icon: 'pi pi-shield',
                    canSee: this.$gate.allows('viewAny', 'InstitutionSetting'),
                },
            ];
        },
    },
};
</script>
